import { Accordion } from '@/lib/components/ui/accordion';
import { useStore } from '../hooks/useStore';
import GradingExtra from './GradingExtra';
import GradingQuestion from './GradingQuestion';

const GradingForm = () => {
  const gradingForm = useStore((state) => state.gradingForm);

  if (!gradingForm?.Questions || !gradingForm?.Extras) return null;

  return (
    <section className="mb-4">
      <Accordion type="single" collapsible className="w-full">
        {gradingForm.Questions.map((question) => (
          <GradingQuestion
            key={`question-${question.Id}`}
            question={question}
          />
        ))}
        {gradingForm.Extras.map((extra) => (
          <GradingExtra key={`extra-${extra.Id}`} extra={extra} />
        ))}
      </Accordion>
    </section>
  );
};

export default GradingForm;
